import { render, staticRenderFns } from "./productVideo.vue?vue&type=template&id=0e3684a9&scoped=true&"
import script from "./productVideo.vue?vue&type=script&lang=js&"
export * from "./productVideo.vue?vue&type=script&lang=js&"
import style0 from "./productVideo.vue?vue&type=style&index=0&id=0e3684a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3684a9",
  null
  
)

export default component.exports